import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { Form, Tabs, Button, Space, App, Pagination, Modal, Checkbox, DatePicker, Input } from 'antd';
import { eventBus } from '@/utils/eventBus';
// import PostordersList from '../../components/PostordersList/PostordersList';
import styles from './StoreOrders.module.scss';
import iocn2 from '@/assets/images/组件 2 – 2@2x.png';
import { getStoreOrderList, confirmReceipt } from '@/api/order';

import { orderStatusOptionsMapper } from '@/utils/constants';
import StoreOrdersList from './StoreOrdersList';

import { OrderData } from './order';
import { useTranslation } from 'react-i18next';
import { log } from 'node:console';

// 规格类型
interface Spec {
  lable: string;
  value: string;
  product_base_attribute_id: number;
  is_custom_attribute?: boolean;
}





//tabItems切换 
function generateTabItems(t: (key: string) => string) {
  const orderStatusOptions = orderStatusOptionsMapper();
  const tabItems = [
    { label: t('storeOrders.All'), key: 'all' },
    ...orderStatusOptions.map(option => ({
      label: t('storeOrders.' + option.label),
      key: option.value.toString()
    }))
  ];

  return tabItems;
}


// 根据枚举value获取状态文案
function getStatusLabelByValue(valueStr: string) {
  const options = orderStatusOptionsMapper();
  return options.find(o => o.value.toString() === valueStr)?.label;
}





const StoreOrders: React.FC = () => {
  //国际化语言切换
  const { t, i18n } = useTranslation();
  const tabItems = generateTabItems(t);
  const { message } = App.useApp();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  // 分类切换状态 - Emergency Service默认选中
  const [activeCategory, setActiveCategory] = useState('product');
  const userInfo = useAppSelector((state) => state.user.userInfo);

  //tab切换
  const [activeTab, setActiveTab] = useState('all');

  // 订单数据状态
  const [orders, setOrders] = useState<OrderData[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedOrders, setSelectedOrders] = useState<string[]>([]);
  const [pagination, setPagination] = useState({
    page_num: 1,
    page_size: 10,
    order_status: '',
    keyword: '',
    total: 0,
  });



  // Shipment confirmation modal states
  const [shipmentModalOpen, setShipmentModalOpen] = useState(false);
  const [shipmentModeConfirm, setShipmentModeConfirm] = useState(true); // true = Confirm Shipment; false = Scheduled
  const [shipmentDate, setShipmentDate] = useState<any>(null);
  const [shipmentRemark, setShipmentRemark] = useState('');
  const [shipmentTargetIds, setShipmentTargetIds] = useState<string[]>([]);

  // After-Sales review modal states
  const [afterSalesModalOpen, setAfterSalesModalOpen] = useState(false);
  const [afterSalesAgree, setAfterSalesAgree] = useState(true); // true = Agree; false = Reject
  const [afterSalesRemark, setAfterSalesRemark] = useState('');
  const [afterSalesTargetIds, setAfterSalesTargetIds] = useState<string[]>([]);

  // Delete confirmation modal states
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteTargetIds, setDeleteTargetIds] = useState<string[]>([]);
  // verify confirmation modal states
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const [verifyTargetIds, setVerifyTargetIds] = useState<string[]>([]);


  //获取商家订单列表
  const getStoreOrderListData = (params: any) => {
    console.log(params, 'paramsparamsparamsparams');

    getStoreOrderList(params).then((res: any) => {
      console.log(res, 'getStoreOrderListData');
      if (res.code === 200) {
        setOrders(res.data);


        setPagination(prev => ({
          ...prev,
          page_num: res.pageNum,
          page_size: res.pageSize,
          total: res.total,
        }));
      }
    })
  }

  const handleConfirmAfterSales = () => {
    const count = afterSalesTargetIds.length;
    setAfterSalesModalOpen(false);
    message.success(count > 1 ? `Bulk after-sales reviewed for ${count} orders` : 'After-sales reviewed');
  };
  // 取货码确认取货
  const handleConfirmVerify = () => {
    form.validateFields().then((formValues) => {
      const data = {
        order_id: verifyTargetIds[0],
        pickup_code: formValues?.pickup_code,
        merchant_id: userInfo?.merchant_id
      }
      confirmReceipt(data).then((res: any) => {
        if (res.code === 200) {
          message.success('Confirm receipt successfully');
          form.resetFields();
          setVerifyModalOpen(false);
          // 确认收货后重新获取数据
          const params = {
            ...pagination,
            // 选择all时不传参数
            order_status: activeTab === 'all' ? '' : activeTab,
          };
          getStoreOrderListData(params);
        }
      })
    }).catch((error) => {
      // 表单验证失败，不处理
    });
  }
  const handleConfirmShipment = () => {
    if (!shipmentModeConfirm && !shipmentDate) {
      message.warning('Please select a scheduled shipment time');
      return;
    }
    const count = shipmentTargetIds.length;
    setShipmentModalOpen(false);
    message.success(count > 1 ? `Bulk shipment confirmed for ${count} orders` : 'Shipment confirmed');
  };

  // 批量删除订单 - 显示确认弹出框
  const handleBulkDelete = () => {
    setDeleteTargetIds(selectedOrders);
    setDeleteModalOpen(true);
  };

  // 确认删除订单
  const handleConfirmDelete = () => {
    const count = deleteTargetIds.length;
    // 从当前订单列表中过滤掉选中的订单
    const updatedOrders = orders.filter(order => !deleteTargetIds.includes(order.product_order_id));
    setOrders(updatedOrders);
    // 清空选中状态
    setSelectedOrders([]);
    // 更新分页信息
    setPagination(prev => ({
      ...prev,
      page_num: updatedOrders.length,
    }));
    // 关闭弹出框
    setDeleteModalOpen(false);
    // 显示成功消息
    message.success(count > 1 ? `Successfully deleted ${count} orders` : 'Order deleted successfully');
  };

  // 切换分类
  const handleCategoryChange = (category: string) => {
    setActiveCategory(category);
    setActiveTab('all');
    setSelectedOrders([]);
    // 切换分类时使用静态数据
    // setOrders(orderData);
    // setPagination({
    //   page_num: 1,
    //   page_size: pagination.page_size,
    //   order_status: undefined,
    //   keyword: '',
    //   total: orderData.length,
    // });


  };



  //切换tab事件（根据枚举映射展示内容）
  const changeTab = (key: string) => {
    console.log('key', key);
    setActiveTab(key);
    setSelectedOrders([]);

    const params = {
      ...pagination,
      // 选择all时不传参数
      order_status: key === 'all' ? '' : key,
    };

    setPagination(params);

    getStoreOrderListData(params);

  }

  //消息列表关键字搜索


  // 搜索事件
  const searchAction = () => {

    getStoreOrderListData(pagination);

  }

  // 重置
  const resetSearch = () => {
    const params = {
      ...pagination,
      page_num: 1,
      page_size: 10,
      order_status: '',
      keyword: '',
      total: 0,
    };

    console.log(params, 'params');


    setPagination(params);

    getStoreOrderListData(params);
  }

  // 搜索消息列表处理键盘回车事件
  const searchHandleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchAction();
    }
  }



  //获取商品id
  const [showServicePanel, setShowServicePanel] = useState(false);
  const [serviceOrder, setServiceOrder] = useState<OrderData | null>(null);
  const [serviceStep, setServiceStep] = useState('select');


  //分页change
  const paginationChange = (page: number, pageSize: number) => {

    const params = {
      ...pagination,
      page_num: page,
      page_size: pageSize,
    }
    setPagination(params);

    getStoreOrderListData(params);


  }



  // mounted
  useEffect(() => {
    getStoreOrderListData(pagination);

  }, []);

  return (
    <div className={styles['order-box']}>
      {!showServicePanel && (
        <div className={styles['left-panel']}>
          {/* 分类切换table */}
          <div className={styles['category-switch-container']}>
            <div className={styles['category-switch']}>
              <div
                className={`${styles['category-tab']} ${activeCategory === 'product' ? styles['active'] : ''}`}
                onClick={() => handleCategoryChange('product')}
              >
                {t('storeOrders.OrderList')}
              </div>
              {/* <div 
                className={`${styles['category-tab']} ${activeCategory === 'service' ? styles['active'] : ''}`}
                onClick={() => handleCategoryChange('service')}
              >
                Service Category
              </div> */}
            </div>
          </div>

          {/* 根据分类显示不同内容 */}
          {/* {activeCategory === 'service' ? (
            <div>
              
            </div>
          ) : ( */}
          <>
            <Tabs
              className={styles['favorites-tabs']}
              items={tabItems}
              activeKey={activeTab}
              onChange={changeTab}
            />
            <div className={styles['search-btn-box']}>
              <div className={styles['sidebar-search']}>
                <input
                  value={pagination.keyword}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPagination({ ...pagination, keyword: e.target.value })}
                  onKeyDown={searchHandleKeyDown}
                  type="text"
                  placeholder="Keyword"
                />
              </div>
              <Button onClick={searchAction} className={styles['search-btn']}>{t('storeOrders.Search')}</Button>
              <Button onClick={resetSearch} className={styles['search-reset']}>{t('storeOrders.Reset')}</Button>
            </div>
            <div className={styles['bulk-btn-box']}>
              {/* <Button  className={styles['search-btn']} onClick={() => {
                    if (selectedOrders.length === 0) {
                      message.warning('Please select at least one order');
                      return;
                    }
                    // 打开发货确认弹窗（批量）
                    setShipmentTargetIds(selectedOrders);
                    setShipmentModeConfirm(true);
                    setShipmentDate(null);
                    setShipmentRemark('');
                    setShipmentModalOpen(true);
                  }}>Bulk Shipment Confirmation</Button> */}
              {/* <Button  className={styles['search-reset']} onClick={() => {
                    if (selectedOrders.length === 0) {
                      message.warning('Please select at least one order');
                      return;
                    }
                    setAfterSalesTargetIds(selectedOrders);
                    setAfterSalesAgree(true);
                    setAfterSalesRemark('');
                    setAfterSalesModalOpen(true);
                  }}>Bulk After-Sales Review</Button> */}
              {/* <Button  className={styles['search-reset']} onClick={() => {
                    if (selectedOrders.length === 0) {
                      message.warning('Please select at least one order');
                      return;
                    }
                    handleBulkDelete();
                  }}>Bulk Delete</Button> */}
            </div>
            {/* 表格位置 */}
            <StoreOrdersList
              orders={orders}
              selectedOrders={selectedOrders}
              onSelectionChange={setSelectedOrders}
              onVerifyRequest={(ids) => {
                setVerifyTargetIds(ids);
                setVerifyModalOpen(true);
              }}
              onShipmentRequest={(ids) => {
                setShipmentTargetIds(ids);
                setShipmentModeConfirm(true);
                setShipmentDate(null);
                setShipmentRemark('');
                setShipmentModalOpen(true);
              }}
              onAfterSalesRequest={(ids) => {
                setAfterSalesTargetIds(ids);
                setAfterSalesAgree(true);
                setAfterSalesRemark('');
                setAfterSalesModalOpen(true);
              }}
            />
            <div className={styles['pagination-box']}>
              <Pagination
                current={pagination.page_num}
                pageSize={pagination.page_size}
                total={pagination.total}
                onChange={paginationChange}
                showSizeChanger={false}
                showQuickJumper
                showTotal={(total, range) => ` Items ${range[0]}-${range[1]} of ${total} total`}
              />
            </div>
          </>
          {/* )} */}
        </div>
      )}
      {/* Shipment Confirmation Modal */}
      <Modal
        className={styles['shipment-modal']}

        title={<div style={{ fontSize: 24, textAlign: 'center' }}>{t('storeOrders.Audit')}</div>}
        open={shipmentModalOpen}
        onCancel={() => setShipmentModalOpen(false)}
        footer={null}
        width={720}
        style={{ top: 250 }}
      >
        <div style={{ height: 50, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ minWidth: 60 }}>*{t('storeOrders.Audit')}:</span>
          <Checkbox checked={shipmentModeConfirm} onChange={() => setShipmentModeConfirm(true)}>{t('storeOrders.ConfirmShipment')}</Checkbox>
          <Checkbox checked={!shipmentModeConfirm} onChange={() => setShipmentModeConfirm(false)}>{t('storeOrders.ScheduledShipment')}</Checkbox>
          {!shipmentModeConfirm && (
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ minWidth: 260 }} onChange={(v) => setShipmentDate(v)} />
          )}
        </div>
        <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ minWidth: 60 }}>{t('storeOrders.Remark')}:</span>
          <Input placeholder="Remark" value={shipmentRemark} onChange={(e) => setShipmentRemark(e.target.value)} />
        </div>
        <div className={styles['modal-btn-box']}>
          <Button onClick={() => setShipmentModalOpen(false)} className={styles['search-reset']}>{t('storeOrders.Cancel')}</Button>
          <Button type="primary" className={styles['search-btn']} onClick={handleConfirmShipment}>{t('storeOrders.Confirm')}</Button>
        </div>
      </Modal>
      {/* verify Confirmation Modal */}
      <Modal
        className={styles['shipment-modal']}

        title={<div style={{ fontSize: 24, textAlign: 'center' }}>{t('storeOrders.VerifyPickupCode')}</div>}
        open={verifyModalOpen}
        onCancel={() => setVerifyModalOpen(false)}
        footer={null}
        width={720}
        style={{ top: 250 }}
      >
        <div style={{ marginBottom: 24, marginTop: 24, display: 'flex', alignItems: 'center', paddingLeft: 30 }}>
          <Form form={form} requiredMark>
            <Form.Item
              label={<><span>*</span>{t('storeOrders.PickupCode')}</>}
              name="pickup_code"
              // validateStatus="success"
              rules={[{ required: true, message: t('storeOrders.PickupCode') }]}
            >
               <Input.OTP  />
            </Form.Item>
          </Form>
        </div>
        <div className={styles['modal-btn-box']}>
          <Button onClick={() => setVerifyModalOpen(false)} className={styles['search-reset']}>{t('storeOrders.Cancel')}</Button>
          <Button type="primary" className={styles['search-btn']} onClick={handleConfirmVerify}>{t('storeOrders.Confirm')}</Button>
        </div>
      </Modal>

      {/* After-Sales Review Modal */}
      <Modal
        className={styles['shipment-modal']}
        title={<div style={{ fontSize: 24, textAlign: 'center' }}>{t('storeOrders.AfterSalesReview')}</div>}
        open={afterSalesModalOpen}
        onCancel={() => setAfterSalesModalOpen(false)}
        footer={null}
        width={720}
        style={{ top: 250 }}
      >
        <div style={{ height: 50, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ minWidth: 60 }}>*{t('storeOrders.Audit')}:</span>
          <Checkbox checked={afterSalesAgree} onChange={() => setAfterSalesAgree(true)}>*{t('storeOrders.Agree')}</Checkbox>
          <Checkbox checked={!afterSalesAgree} onChange={() => setAfterSalesAgree(false)}>{t('storeOrders.Reject')}</Checkbox>
        </div>
        <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ minWidth: 60 }}>{t('storeOrders.Remark')}:</span>
          <Input placeholder="Remark" value={afterSalesRemark} onChange={(e) => setAfterSalesRemark(e.target.value)} />
        </div>
        <div className={styles['modal-btn-box']}>
          <Button onClick={() => setAfterSalesModalOpen(false)} className={styles['search-reset']}>{t('storeOrders.Remark')}</Button>
          <Button type="primary" className={styles['search-btn']} onClick={handleConfirmAfterSales}>{t('storeOrders.Confirm')}</Button>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        className={styles['shipment-modal']}
        title={<div style={{ fontSize: 24, textAlign: 'center' }}>{t('storeOrders.DeleteConfirmation')}</div>}
        open={deleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        footer={null}
        width={500}
        style={{ top: 250 }}
      >
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <div style={{ fontSize: 16, color: '#333', marginBottom: 20 }}>
            {t('storeOrders.Areyousureyouwanttodelete')} {deleteTargetIds.length} {deleteTargetIds.length > 1 ? 'orders' : 'order'}?
          </div>
          <div style={{ fontSize: 14, color: '#666', marginBottom: 30 }}>
            {t('storeOrders.Thisactioncannotbeundone')}.
          </div>
        </div>
        <div className={styles['modal-btn-box']}>
          <Button onClick={() => setDeleteModalOpen(false)} style={{ borderColor: '#2AAD61', color: '#2AAD61' }}>{t('storeOrders.Cancel')}</Button>
          <Button type="primary" style={{ background: '#ff4d4f', borderColor: '#ff4d4f' }} onClick={handleConfirmDelete}>{t('storeOrders.Delete')}</Button>
        </div>
      </Modal>
    </div>
  );
};

export default StoreOrders; 